// File: frontend/src/components/LanguageToggle.jsx

import React from 'react';
import { useLanguage } from '../LanguageContext';

export default function LanguageToggle({ className = '' }) {
  const { language, setLanguage } = useLanguage();

  return (
    <div 
      className={`inline-flex items-center bg-black/20 backdrop-blur-xs p-0.5 rounded-lg border border-white/20 text-xs font-bold select-none ${className}`}
      title="Toggle English / Traditional Mandarin (切換英文 / 繁體中文)"
    >
      <button
        type="button"
        onClick={() => setLanguage('en')}
        className={`px-2 py-1 rounded-md transition-all cursor-pointer ${
          language === 'en'
            ? 'bg-white dark:bg-gray-800 text-blue-800 shadow-xs'
            : 'text-white/80 hover:text-white hover:bg-white/10'
        }`}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLanguage('zh')}
        className={`px-2 py-1 rounded-md transition-all cursor-pointer ${
          language === 'zh'
            ? 'bg-white dark:bg-gray-800 text-blue-800 shadow-xs'
            : 'text-white/80 hover:text-white hover:bg-white/10'
        }`}
      >
        繁中
      </button>
    </div>
  );
}
